export default "__VITE_ASSET__CkUoIF_8__"